import React from 'react';
import { Statistic } from 'semantic-ui-react';
import { FormattedMessage } from 'react-intl';

const TableStatistics = ({ total, count }) => (
  <Statistic.Group size="mini">
    <Statistic horizontal>
      <Statistic.Value>
        {count}
      </Statistic.Value>
      <Statistic.Label>
        <FormattedMessage id="datasets.table.footer.shown" />
      </Statistic.Label>
    </Statistic>
    <Statistic horizontal>
      <Statistic.Value>
        {total}
      </Statistic.Value>
      <Statistic.Label>
        <FormattedMessage id="datasets.table.footer.total" />
      </Statistic.Label>
    </Statistic>
  </Statistic.Group>
);

export default TableStatistics;
